namespace TabAurous.OMS {
    export interface TargetMasterForm {
        BaseItemTypeId: Serenity.LookupEditor;
    }

    export class TargetMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.TargetMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TargetMasterForm.init)  {
                TargetMasterForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;

                Q.initFormType(TargetMasterForm, [
                    'BaseItemTypeId', w0
                ]);
            }
        }
    }
}
